module.exports = "/_next/static/images/Hero@2x-fbdd45a978d47def60586d5f478c73a6.png";